import { gql } from 'apollo-boost';

export const READ_NOTIFICAITON_MUTATION = gql`
mutation createReadNotification($input:CreateReadNotificationInput!){
    Result:createReadNotification(input:$input){
        id
        personId
        notificationId
    }
}
`;
